import React from 'react';
import type { HeadFC } from 'gatsby';

import Hero from '../components/Hero/Hero';
import Partners from '../components/Partners/Partners';
import Steps from '../components/Steps/Steps';
import WhyCheqrboard from '../components/WhyCheqrboard/WhyCheqrboard';
import VisitorEngagement from '../components/VisitorEngagement/VisitorEngagement';
import ContentPlatform from '../components/ContentPlatform/ContentPlatform';
import VenueAnalytics from '../components/VenueAnalytics/VenueAnalytics';
import ContactUs from '../components/ContactUs/ContactUs';
import Testimonial from '../components/Testimonial/Testimonial';
import FAQ from '../components/FAQ/FAQ';
import Footer from '../components/Footer/Footer';

const pageStyles = {
  position: 'relative',
  backgroundColor: '#fafafa',
  width: '100%',
  height: '11955px',
  overflow: 'hidden',
  textAlign: 'left',
  fontSize: '32px',
  color: '#333215',
  fontFamily: 'Poppins',
};

const IndexPage: React.FC = () => {
  return (
    <main className='min-h-screen'>
      <Hero />
      <Partners />
      <Steps />
      <WhyCheqrboard />
      <VisitorEngagement />
      <ContentPlatform />
      <VenueAnalytics />
      <ContactUs />
      {/* <Testimonial /> */}
      <FAQ />
      <Footer />
    </main>
  );
};

export default IndexPage;

export const Head: HeadFC = () => <title>CheQRboard</title>;
